export default "__VITE_PUBLIC_ASSET__178aa6e6__"